import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

type PhotoProps = {
  src: string;
  alt: string;
  credit: string;
  /** Softens the photo into the page instead of framing it as a card. */
  fade?: 'edge' | 'globe';
  sx?: SxProps<Theme>;
};

const edgeMask = {
  WebkitMaskImage: {
    xs: 'linear-gradient(180deg, transparent, #000 18%, #000 78%, transparent)',
    md: 'linear-gradient(90deg, transparent, #000 24%, #000 100%)',
  },
  maskImage: {
    xs: 'linear-gradient(180deg, transparent, #000 18%, #000 78%, transparent)',
    md: 'linear-gradient(90deg, transparent, #000 24%, #000 100%)',
  },
};

/** A photograph. The license credit stays in the page for inspection and is not shown as a caption. */
const Photo = ({ src, alt, credit, fade, sx }: PhotoProps) => {
  return (
    <Box
      component="figure"
      sx={{
        m: 0,
        position: 'relative',
        ...sx,
        ...(fade === 'globe' ? { overflow: 'hidden', borderRadius: '50%' } : {}),
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        title={credit}
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: fade ? 0 : 2,
          ...(fade === 'edge' ? edgeMask : {}),
          ...(fade === 'globe' ? { transform: 'scale(1.88)' } : {}),
        }}
      />
      <Typography
        component="figcaption"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clipPath: 'inset(50%)',
          whiteSpace: 'nowrap',
          border: 0,
        }}
      >
        {credit}
      </Typography>
    </Box>
  );
};

export default Photo;
